<div class="modal-header">
    <div class="d-flex justify-content-between align-items-center px-4 pt-1 w-100">
        <div class="r-text-xl text-primary">{{title}}</div>
        <div class="close text-primary text-end pointer" data-cy="closeMarkdownModalButtonHeader" (click)="activeModal.close()">Close x</div>
    </div>
</div>
<div class="modal-body" data-cy="markdownModalBody"><sbw-markdown-html [md]="md"></sbw-markdown-html></div>
<div class="modal-footer"><button class="btn fw-700 ms-3 btn-bevel bevel-5" data-cy="closeMarkdownModalButtonFooter" (click)="close()">Close</button></div>
